<template>
  <div id="chart-line" v-loading="chartLoading" style="position: relative">
    <apexchart
      ref="apexFft"
      id="apexFft"
      type="line"
      height="360"
      :options="chartOptions"
      :series="series"
    ></apexchart>
    <ChartElectricalTimeMini
      :style="{ paddingTop: '1rem' }"
      :unit="unit"
      :rawData="rawData"
      :samplingRate="samplingRate"
      v-model="visibleRange"
      v-on:childTimeDomain="updateTimeChartMinMax"
    ></ChartElectricalTimeMini>
    <span style="position: absolute; top: 48px; left: 5px">
      <span style="margin-left: 5px" @click="scale = 'LINEAR'">
        <el-button :type="scale == 'LINEAR' ? 'primary' : ''" size="mini"
          >{{ $t('measurement.scale.linear') }}
        </el-button>
      </span>
      <span style="margin-left: 5px" @click="scale = 'LOGARITHMIC'">
        <el-button :type="scale == 'LOGARITHMIC' ? 'primary' : ''" size="mini"
          >{{ $t('measurement.scale.logarithmic') }}
        </el-button>
      </span>
    </span>
    <div
      style="
        order: 0;
        position: absolute;
        top: 0;
        justify-content: center;
        align-items: center;
        display: flex;
        flex-direction: row;
        width: 100%;
      "
    >
      <div style="margin: 5px" @click="Backward">
        <el-button size="mini"><em class="fas fa-backward"></em> </el-button>
      </div>
      <div style="margin: 5px" @click="StepBackward">
        <el-button size="mini"
          ><em class="fas fa-step-backward"></em>
        </el-button>
      </div>
      <div style="margin: 5px; font-size: 20px; text-align: center">
        {{ Hz }}<br />{{ Value }}
      </div>
      <div style="margin: 5px" @click="StepForward">
        <el-button size="mini"
          ><em class="fas fa-step-forward"></em>
        </el-button>
      </div>
      <div style="margin: 5px" @click="Forward">
        <el-button size="mini"><em class="fas fa-forward"></em> </el-button>
      </div>
    </div>
    <span style="position: absolute; top: 10px; left: 50px">
      <span style="margin-top: 0px">{{
        `${this.timeChartMinMax[0].toFixed(
          2
        )} - ${this.timeChartMinMax[1].toFixed(2)} 
          ${$t("common.second")}`
      }}</span>
    </span>
    <span style="position: absolute; top: 10px; right: 50px">
      <span>
        <span style="margin-top: 0px">Zoom: {{ zoomLevel + 1 }}X</span>
        <span style="margin-left: 5px; z-index: 9999" @click="zoomIn">
          <el-button size="mini"
            ><em class="fas fa-search-plus"></em>
          </el-button>
        </span>
        <span style="margin-left: 5px; z-index: 9999" @click="zoomOut">
          <el-button size="mini"
            ><em class="fas fa-search-minus"></em>
          </el-button>
        </span>
        <span style="margin-left: 5px; z-index: 9999" @click="zoomReset">
          <el-button size="mini"><em class="fas fa-home"></em> </el-button>
        </span>
        <span style="margin-left: 5px; z-index: 9999">
          <el-dropdown size="mini" @command="handleCommand" trigger="click">
            <el-button size="mini">
              {{ $t("common.download") }}
              <em class="fas fa-download"></em>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="csvDownload">
                {{ $t("common.csvDownload") }}
              </el-dropdown-item>
              <el-dropdown-item command="pngDownload">
                {{ $t("common.pngDownload") }}
              </el-dropdown-item>
              <el-dropdown-item command="svgDownload">
                {{ $t("common.svgDownload") }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </span>
        <br />
      </span>
    </span>
    <el-row class="toolbox"> </el-row>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { mapState } from "vuex";
import { apexDownload, Keyboard } from "../util";
import ChartElectricalTimeMini from "./Chart_Electrical_TimeMini";
import cachios from "cachios";

export default {
  name: "fft-chart",
  events: [],
  props: {
    point: {
      type: Object,
    },
    bearing: {
      type: Object,
    },
    rawData: {
      type: Array,
    },
    samplingRate: {
      type: Number,
      default: 0,
    },

    referenceFrequency: {
      type: Number,
    },
    integrateEnabled: {
      type: Boolean,
      default: true,
    },
    faultFrequencyEnabled: {
      type: Boolean,
      default: true,
    },
    sensor: {
      type: String,
      default: "current",
    },
    unit: {
      type: String,
    },
  },
  components: {
    apexchart: VueApexCharts,
    ChartElectricalTimeMini,
  },
  mounted() {
    window.addEventListener("mousedown", this.mouseDown);
    this.visibleRange = [0, this.rawData.length - 1];
    this.init();
  },
  data() {
    return {
      visibleRange: [],
      faultFrequency: "bearing",
      timeChartMinMax: [0, 0],
      chartLoading: false,
      mouseBeforeX: 0,
      mouseAfterX: 0,
      freqType: "Frequency",
      frequencyDomainValue: undefined,
      fftType: "Grms",
      window: "rectangular",
      harmonics: true,
      activeData: [],
      logarithmicBooleen: false,
      activeDataPointIndex: 0,
      maxPointValue: 0,
      maxPointFreq: 0,
      frequencyDomain: [],
      zoomLevel: 0,
      maxValue: 0,
      maxValuePoint: undefined,
      maxZoomLevel: 10,
      FFTgrmsSerie: [],
      FFTvrmsSerie: [],
      series: [
        {
          data: [],
        },
      ],
      scale: "LOGARITHMIC",
      windows: ["rectangular", "hanning", "flattop", "hamming", "blackman"],
      anootationPosition: 0,
      chartOptions: {
        tooltip: {
          enabled: true,
          shared: true,
          followCursor: false,
          style: {
            fontSize: "8px",
            fontFamily: undefined,
          },
          onDatasetHover: {},
          x: {
            show: false,
          },
          marker: {
            show: false,
          },
        },

        chart: {
          offsetY: 20,
          parentHeightOffset: -20,
          id: "chart",
          type: "line",
          defaultLocale: "en",
          locales: [
            {
              name: "en",
              options: {
                toolbar: {
                  exportToSVG: this.$t("chart.toolbar.exportToSVG"),
                  exportToPNG: this.$t("chart.toolbar.exportToPNG"),
                  exportToCSV: this.$t("chart.toolbar.exportToCSV"),
                  menu: this.$t("chart.toolbar.menu"),
                  selection: this.$t("chart.toolbar.selection"),
                  selectionZoom: this.$t("chart.toolbar.selectionZoom"),
                  zoomIn: this.$t("chart.toolbar.zoomIn"),
                  zoomOut: this.$t("chart.toolbar.zoomOut"),
                  pan: this.$t("chart.toolbar.pan"),
                  reset: this.$t("chart.toolbar.reset"),
                },
              },
            },
          ],
          zoom: {
            enabled: true,
            type: "x",
            autoScaleYaxis: false,
            zoomedArea: {
              fill: {
                color: "#90CAF9",
                opacity: 0.4,
              },
              stroke: {
                color: "#0D47A1",
                opacity: 0.4,
                width: 1.5,
              },
            },
          },
          events: {
            click: this.dataPointClick,
            updated: this.chartUpdated,
          },
          animations: {
            enabled: false,
            dynamicAnimation: {
              enabled: false,
            },
          },
          toolbar: {
            tools: {
              download: false,
              pan: true,
              zoom: false,
              zoomin: false,
              zoomout: false,
              reset: false,
            },
            autoSelected: "pan",
            show: true,
          },
        },
        annotations: {
          xaxis: [],
          point: [],
        },
        colors: ["#0071BD"],
        stroke: {
          width: 1.5,
          curve: "straight",
        },
        dataLabels: {
          enabled: false,
        },
        fill: {
          opacity: 1,
        },
        markers: {
          size: 0,
          hover: {
            sizeOffset: 6,
          },
        },
        xaxis: {
          type: "numeric",
          tickAmount: 20,
        },
        yaxis: {
          logarithmic: this.logarithmicBooleen,
          type: "numeric",
          labels: {
            formatter: function (e) {
              try {
                return parseFloat(e).toFixed(4);
              } catch (e) {
                return 0;
              }
            },
          },
        },
        grid: {
          show: !0,
          padding: {
            top: 50,
          },
          xaxis: {
            lines: {
              show: true,
            },
          },
          yaxis: {
            lines: {
              show: true,
            },
          },
        },
        theme: {},
      },
    };
  },
  computed: {
    ...mapState("measurementsDetails", ["rawdataIndex"]),
    Hz: function () {
      return (
        Number(this.frequencyDomain[this.activeDataPointIndex]).toFixed(4) +
        ` ${this.$t(`chart.ft${this.freqType}`)}`
      );
    },
    faultFrequencies: function () {
      let f = ["bearing"];
      if (
        this.point &&
        this.point.type &&
        this.point.type.includes("GearBox")
      ) {
        f.push("gmf");
      }
      return f;
    },
    sensorUnit: function () {
      switch (this.sensor) {
        case "current":
          return "A";
        case "voltage":
          return "V";
      }
      return "V";
    },
    Value: function () {
      try {
        if (!this.activeData.length) return "";
        return (
          this.activeData[this.activeDataPointIndex].toFixed(4) +
          (this.scale == "LINEAR" ? this.sensorUnit : `${this.sensorUnit}(dB)`)
        );
      } catch (e) {
        return 0;
      }
    },
  },
  methods: {
    getYAxisLabel() {
      return this.sensorUnit;
    },
    updateTimeChartMinMax(timeDomain) {
      this.timeChartMinMax = timeDomain;
    },
    mouseDown(e) {
      this.mouseBeforeX = e.offsetX;
    },
    handleCommand(command) {
      switch (command) {
        case "csvDownload":
          apexDownload.csvDownload(this, "apexFft");
          break;
        case "pngDownload":
          apexDownload.pngDownload(this);
          break;
        case "svgDownload":
          apexDownload.svgDownload(this);
          break;
      }
      setTimeout(() => {
        this.init();
      }, 100);
    },
    chartUpdated() {
      this.BindKeyborad();
      this.chartLoading = false;
      this.drawAnnotations();
    },
    closestValueIndex(arr, v) {
      if (this.freqType == "RPM") {
        v = v * 60;
      }
      let closestValue = arr.reduce((a, b) => {
        return Math.abs(b - v) < Math.abs(a - v) ? b : a;
      });
      let index = arr.indexOf(closestValue);
      return index;
    },
    Backward() {
      this.activeDataPointIndex = this.activeDataPointIndex - 10;
      this.drawAnnotations();
    },
    Forward() {
      this.activeDataPointIndex = this.activeDataPointIndex + 10;
      this.drawAnnotations();
    },
    StepBackward() {
      this.activeDataPointIndex = this.activeDataPointIndex - 1;
      this.drawAnnotations();
    },
    StepForward() {
      this.activeDataPointIndex = this.activeDataPointIndex + 1;
      this.drawAnnotations();
    },
    BindKeyborad() {
      Keyboard.detach(this.$refs.apexFft.$el);
      Keyboard.attach(this.$refs.apexFft.$el);
      Keyboard.add_binding({
        altKey: true,
        key: "ArrowLeft",
        callback: this.Backward,
      });
      Keyboard.add_binding({
        altKey: true,
        key: "ArrowRight",
        callback: this.Forward,
      });
      Keyboard.add_binding({
        key: "ArrowLeft",
        callback: this.StepBackward,
      }),
        Keyboard.add_binding({
          key: "ArrowRight",
          callback: this.StepForward,
        });
      Keyboard.add_binding({
        key: "Enter",
        callback: () => {
          this.zoomReset();
        },
      });
      Keyboard.add_binding({
        key: "ArrowUp",
        callback: () => {
          this.zoomIn();
        },
      });
      Keyboard.add_binding({
        key: "ArrowDown",
        callback: () => {
          this.zoomOut();
        },
      });
      this.drawAnnotations();
    },
    zoomIn() {
      if (this.zoomLevel + 1 > this.maxZoomLevel) {
        return;
      }
      this.zoomLevel = this.zoomLevel + 1;
      this.zoom();
    },
    zoomOut() {
      if (this.zoomLevel - 1 < 0) {
        return;
      }
      this.zoomLevel = this.zoomLevel - 1;
      this.zoom();
    },
    zoomReset() {
      // let x = this.closestValueIndex(
      //   this.frequencyDomain,
      //   this.referenceFrequency
      // );
      // this.activeDataPointIndex = x;
      this.zoomLevel = 0;
      this.zoom();
    },
    zoom() {
      let offset =
        this.frequencyDomain[this.frequencyDomain.length - 1] /
        Math.pow(2, this.zoomLevel);
      let centerValue = this.frequencyDomain[this.activeDataPointIndex];
      let min = centerValue - offset;
      let max = centerValue + offset;
      if (min < 0) min = this.frequencyDomain[0];
      if (this.zoomLevel == 0) {
        this.$refs.apexFft.zoomX(
          this.frequencyDomain[0],
          this.frequencyDomain[this.frequencyDomain.length - 1]
        );
      } else {
        this.$refs.apexFft.zoomX(min, max);
      }

      this.drawAnnotations();
    },
    drawHarmonics() {
      this.$refs.apexFft.removeAnnotation("harmonics");
      if (this.harmonics) {
        try {
          let freq_index = this.frequencyDomain[this.activeDataPointIndex];
          for (var i = 1; i <= 10; i++) {
            var x = freq_index * i;
            let annotation = {
              id: "harmonics",
              x,
              borderColor: "#775DD0",
              label: {
                style: {
                  background: "#fff",
                  color: "#777",
                  fontSize: "12px",
                  fontWeight: 400,
                  fontFamily: undefined,
                  cssClass: "apexcharts-xaxis-annotation-label",
                },
                text: `${i}x`,
                orientation: "horizontal",
              },
            };
            this.$refs.apexFft.addXaxisAnnotation(annotation, false);
          }
        } catch (e) {
          //console.error(e);
        }
      }
    },
    drawPeak() {
      try {
        if (
          this.activeData[this.activeDataPointIndex] >
            this.activeData[this.activeDataPointIndex - 1] &&
          this.activeData[this.activeDataPointIndex] >
            this.activeData[this.activeDataPointIndex + 1]
        ) {
          this.maxPointValue = this.activeData[this.activeDataPointIndex];
          this.maxPointFreq = this.frequencyDomain[this.activeDataPointIndex];
          let maxPointAnnotation = {
            x: this.maxPointFreq,
            y: this.maxPointValue,
            marker: {
              size: 2,
            },

            image: {
              path: "/images/peak.png",
              size: 5,
            },
          };
          this.$refs.apexFft.addPointAnnotation(maxPointAnnotation, false);
        }
      } catch (e) {
        console.log(e);
      }
    },
    drawReferenceFrequency() {
      try {
        let ref = this.referenceFrequency;
        ref = this.freqType.toUpperCase() == "RPM" ? ref * 60 : ref;
        let annotation = {
          x: ref,
          offsetY: -40,
          strokeDashArray: 1,
          borderColor: "#d05dcc",
          label: {
            offsetY: -40,

            style: {
              background: "#00c500",
              color: "white",
              fontSize: "12px",
              fontWeight: 400,
              fontFamily: undefined,
              cssClass: "apexcharts-xaxis-annotation-label",
            },
            text: `REF(${ref.toFixed(2)})`,
            orientation: "horizontal",
          },
        };
        this.$refs.apexFft.addXaxisAnnotation(annotation, false);
      } catch (e) {
        //console.error(e);
      }
    },
    drawBPFO() {
      try {
        let bpfo = this.referenceFrequency * this.bearing.bpfo * 60;
        bpfo = this.freqType.toUpperCase() == "RPM" ? bpfo * 60 : bpfo;
        let annotation = {
          x: bpfo,
          offsetY: -20,
          strokeDashArray: 1,
          borderColor: "#d05dcc",
          label: {
            offsetY: -20,

            style: {
              background: "#fff",
              color: "#777",
              fontSize: "12px",
              fontWeight: 400,
              fontFamily: undefined,
              cssClass: "apexcharts-xaxis-annotation-label",
            },
            text: `BPFO (${bpfo.toFixed(2)})`,
            orientation: "horizontal",
          },
        };
        this.$refs.apexFft.addXaxisAnnotation(annotation, false);
      } catch (e) {
        //console.error(e);
      }
    },
    drawHarmonic(label, x) {
      try {
        let annotation = {
          x: x,
          offsetY: -20,
          strokeDashArray: 1,
          borderColor: "#d05dcc",
          label: {
            offsetY: -20,
            style: {
              background: "#fff",
              color: "#777",
              fontSize: "12px",
              fontWeight: 400,
              fontFamily: undefined,
              cssClass: "apexcharts-xaxis-annotation-label",
            },
            text: `${label} (${x.toFixed(2)})`,
            orientation: "horizontal",
          },
        };
        this.$refs.apexFft.addXaxisAnnotation(annotation, false);
      } catch (e) {
        //console.error(e);
      }
    },
    drawBSF() {
      try {
        let bsf = this.referenceFrequency * this.bearing.bsf * 60;
        bsf = this.freqType.toUpperCase() == "RPM" ? bsf * 60 : bsf;
        let annotation = {
          x: bsf,
          offsetY: -20,
          strokeDashArray: 1,
          borderColor: "#d05dcc",
          label: {
            offsetY: -20,
            style: {
              background: "#fff",
              color: "#777",
              fontSize: "12px",
              fontWeight: 400,
              fontFamily: undefined,
              cssClass: "apexcharts-xaxis-annotation-label",
            },
            text: `BSF (${bsf.toFixed(2)})`,
            orientation: "horizontal",
          },
        };
        this.$refs.apexFft.addXaxisAnnotation(annotation, false);
      } catch (e) {
        //console.error(e);
      }
    },
    drawBPFI() {
      try {
        let bpfi = this.referenceFrequency * this.bearing.bpfi * 60;
        bpfi = this.freqType.toUpperCase() == "RPM" ? bpfi * 60 : bpfi;

        let annotation = {
          x: bpfi,
          offsetY: -20,
          strokeDashArray: 1,
          borderColor: "#d05dcc",
          label: {
            offsetY: -20,

            style: {
              background: "#fff",
              color: "#777",
              fontSize: "12px",
              fontWeight: 400,
              fontFamily: undefined,
              cssClass: "apexcharts-xaxis-annotation-label",
            },
            text: `BPFI (${bpfi.toFixed(2)})`,
            orientation: "horizontal",
          },
        };
        this.$refs.apexFft.addXaxisAnnotation(annotation, false);
      } catch (e) {
        //console.error(e);
      }
    },
    drawFTF(isFTF) {
      try {
        let ftf =
          this.referenceFrequency * isFTF
            ? this.bearing.ftf * 60
            : this.bearing.ftfi * 60;
        ftf = this.freqType.toUpperCase() == "RPM" ? ftf * 60 : ftf;

        let annotation = {
          x: ftf,
          offsetY: -20,
          strokeDashArray: 1,
          borderColor: "#d05dcc",
          label: {
            offsetY: -20,
            style: {
              background: "#fff",
              color: "#777",
              fontSize: "12px",
              fontWeight: 400,
              fontFamily: undefined,
              cssClass: "apexcharts-xaxis-annotation-label",
            },
            text: `${isFTF ? "FTF" : "FTFI"} (${ftf.toFixed(2)})`,
            orientation: "horizontal",
          },
        };
        this.$refs.apexFft.addXaxisAnnotation(annotation, false);
      } catch (e) {
        //console.error(e);
      }
    },
    drawAnnotations() {
      this.$refs.apexFft.clearAnnotations();
      if (this.referenceFrequency) {
        this.drawReferenceFrequency();
      }
      if (
        this.faultFrequency == "bearing" &&
        this.bearing &&
        this.referenceFrequency
      ) {
        this.drawFTF(!!this.bearing.ftf);
        this.drawBPFI();
        this.drawBPFO();
        this.drawBSF();
      } else if (
        this.faultFrequency == "gmf" &&
        this.point.numberOfGearTeethAtDriverShaft &&
        this.referenceFrequency
      ) {
        let gmf =
          this.referenceFrequency * this.point.numberOfGearTeethAtDriverShaft;
        gmf = this.freqType.toUpperCase() == "RPM" ? gmf * 60 : gmf;
        //generate gmf harmonics
        let gmfHarmonics = [];
        for (let i = 1; i <= 10; i++) {
          gmfHarmonics.push(gmf * i);
          this.drawHarmonic("GMF" + i, gmf * i);
        }
      }
      this.drawHarmonics();
      this.drawPeak();
    },
    dataPointClick(event, chartContext, config) {
      this.mouseAfterX = event.offsetX;
      if (
        Math.abs(this.mouseAfterX - this.mouseBeforeX) < 5 &&
        !event.ctrlKey
      ) {
        this.$message({
          type: "info",
          message: this.$t("chart.warningForCTRLClick"),
        });
      }
      if (event.ctrlKey) {
        if (config.dataPointIndex == -1) return;
        this.$refs.apexFft.clearAnnotations();
        this.activeDataPointIndex = config.dataPointIndex;
        this.maxPointValue = 0;
        this.drawAnnotations();
      }
    },
    init() {
      if (this.rawData) {
        this.chartLoading = true;
        cachios
          .post(`${process.env.VUE_APP_VIBRATION_APIURL}/signal/spectrum`, {
            half: true,
            dcOffset: true,
            window: this.window,
            mode: this.fftType == "Vrms" ? "velocity" : "accelerometer",
            signal: this.rawData.slice(
              this.visibleRange[0],
              this.visibleRange[1] + 1
            ),
            samplingRate: this.samplingRate,
          })
          .then((response) => {
            this.frequencyDomainValue = response.data.results.x;
            this.activeData = response.data.results.y;
            if (this.scale == "LOGARITHMIC") {
              this.activeData = this.activeData
                .map((x) => 20 * Math.log10(x))
                .map((x) => (x == -Infinity ? 0 : x));
            }
            if (this.freqType == "Frequency") {
              this.frequencyDomain = this.frequencyDomainValue.map((a) => a);
            } else {
              this.frequencyDomain = this.frequencyDomainValue.map(
                (x) => x * 60
              );
            }
            if (this.referenceFrequency && this.referenceFrequency != 0) {
              let x = this.closestValueIndex(
                this.frequencyDomain,
                this.referenceFrequency
              );
              this.activeDataPointIndex = x;
              if (
                this.activeDataPointIndex + 1 ==
                this.frequencyDomain.length
              ) {
                this.activeDataPointIndex = this.activeDataPointIndex - 1;
              }
            }
            this.PrepareDataToPlot();
          });
      }

      setTimeout(() => {
        this.zoom();
      }, 100);
    },
    PrepareDataToPlot() {
      var logBol = this.logarithmicBooleen;

      this.chartOptions = {
        xaxis: {
          categories: this.frequencyDomain,
          labels: {
            formatter: function (val) {
              if (val) {
                return val.toFixed(2);
              } else {
                return "";
              }
            },
          },
          title: {
            text: this.$t(`chart.f${this.freqType}`),
            offsetY: 80,
          },
        },
        yaxis: {
          logarithmic: this.logarithmicBooleen,
          type: "numeric",
          tickAmount: 10,
          title: {
            text:
              this.unit.toUpperCase() +
              (this.scale == "LINEAR" ? "rms" : "rms(dB)"),
          },
          labels: {
            formatter: function (e) {
              if (logBol) {
                return parseFloat(e).toFixed(0);
              } else {
                return parseFloat(e).toFixed(4);
              }
            },
          },
        },
      };

      if (this.logarithmicBooleen) {
        this.activeData = this.activeData.map((x) => x * 100000000);
      }
      this.series = [
        {
          name: this.unit + "RMS",
          data: this.activeData,
        },
      ];
    },
  },
  watch: {
    visibleRange: function () {
      this.init();
    },
    activeDataPointIndex: function () {
      if (this.activeDataPointIndex < 0) {
        this.activeDataPointIndex = 0;
      } else if (this.activeDataPointIndex >= this.frequencyDomain.length) {
        this.activeDataPointIndex = this.frequencyDomain.length - 1;
      }
    },
    rawData: function () {
      setTimeout(() => {
        this.init();
      }, 100);
    },
    scale: function () {
      setTimeout(() => {
        this.init();
        console.log("scale");
      }, 100);
    },
    fftType: function () {
      setTimeout(() => {
        this.init();
      }, 100);
      setTimeout(() => {
        this.$refs.apexFft.$el.focus();
        this.zoomLevel -= 1;
        this.zoomIn();
      }, 200);
    },
    referenceFrequency: function () {
      this.drawAnnotations();
    },
    freqType: function () {
      setTimeout(() => {
        this.init();
      }, 100);
    },
    logarithmicBooleen: function () {
      setTimeout(() => {
        this.init();
      }, 100);
    },
  },
};
</script>
<style>
.apexcharts-toolbar {
  top: 15px !important;
  right: 5px !important;
}
</style>
<style scoped>
*:focus {
  outline: -webkit-focus-ring-color auto 0px;
}

.apexcharts-tooltip.apexcharts-theme-light {
  line-height: 9px;
  padding-bottom: 0px;
}

.apexcharts-tooltip-series-group.apexcharts-active,
.apexcharts-tooltip-series-group:last-child {
  padding-bottom: 0px;
}

.apexcharts-tooltip-series-group.apexcharts-active {
  padding-left: 4px;
  padding-right: 4px;
  padding-bottom: 0px;
}
</style>
